export { SkillPatient as default } from './SkillPatient';
